import { useState, useEffect, useRef } from 'react';
import { asyncWait } from '../helpers';

export type SetRetryFunction = (retry: boolean) => Promise<void>;

export default function useRetry<
  /* eslint-disable @typescript-eslint/no-unsafe-function-type */
  /* eslint-disable @typescript-eslint/no-explicit-any */
  AsyncFunction extends Function,
  Args extends any[],
>(
  fn: AsyncFunction,
  args: Args,
): [boolean, (args?: Args) => void, SetRetryFunction] {
  const [showRetry, setShowRetry] = useState(false);
  const isMounted = useRef(false);

  useEffect((): VoidFunction => {
    if (!isMounted.current) isMounted.current = true;
    return (): void => {
      isMounted.current = false;
    };
  });

  const asyncSetShowRetry = async (retry: boolean): Promise<void> => {
    await asyncWait(500);
    if (isMounted.current) setShowRetry(retry);
  };

  const onRetry = (newArgs?: Args): void => {
    const retryArgs = newArgs ? Object.assign(args, newArgs) : args;
    fn(...retryArgs, asyncSetShowRetry);
    setShowRetry(false);
  };

  return [showRetry, onRetry, asyncSetShowRetry];
}
